<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass" scoped>
@import 'component'
</style>

<template lang="pug">

  <div v-if="isLoading">
    <h2 class="is-loading-animation">Подождите...</h2>
  </div>
  <div v-else>
    form(v-on:submit.prevent="submitTelNumber")
      c-form-info(v-bind:message="$t(message)")
      c-form-error(v-bind:message="$t(responseErrorMessage)")

      div.form-group
        div(v-bind:class="isMaskListVisible ? 'active' : 'not-active'" v-on:click="isMaskListVisible = !isMaskListVisible") &plus;{{ phoneCode }}
        input(name="phone-field" type="text" autofocus ref="phoneNumberField" v-model="phoneNumber" v-bind:placeholder="$t('placeholder_phone_number')" )
        transition(name="list")
          ul(v-if="isMaskListVisible")
            li(class="lang-btn" v-for="(lang, key) in countries" v-on:click="onPhoneCodeChange(countries[key]['COUNTRY_CODE'], key)" v-bind:class="phoneCode == countries[key]['COUNTRY_CODE'] ? 'active' : ''" v-bind:key="key")
              span {{ lang['COUNTRY_CODE'] }} &nbsp; {{ lang['FULLNAME'] }}

      div.text-center(v-if="isProduction")
        vue-recaptcha(
          ref="recaptcha"
          size="invisible"
          :sitekey="sitekey"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
        )          

      c-form-submit(v-bind:isDisabled="isInvalidRequestParams()" v-bind:isLoading="requestBeingProcessed") {{ $t('btn_submit') }}

  </div>

</template>

<script>
import InputMask from 'inputmask/dist/inputmask/inputmask';
import VueRecaptcha from 'vue-recaptcha';
import { minLength, numeric, required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';

import * as responseCodes from 'classes/response-codes';
import cFormError from 'components/c-form/c-form-error/component';
import cFormInfo from 'components/c-form/c-form-info/component';
import cFormSubmit from 'components/c-form/c-form-submit/component';
import mFormSubmit from 'mixins/formSubmit';
import mMask from 'mixins/mask';
import * as types from 'store/mutation-types';

import 'inputmask/dist/inputmask/inputmask.numeric.extensions';

export default {
  name: 'FormEnterNumberComponent',
  mixins: [mMask, mFormSubmit],

  components: {
    cFormError,
    cFormInfo,
    cFormSubmit,
    VueRecaptcha,
  },

  data() {
    return {
      message: null,
      isMaskListVisible: false,
      model: {
        phoneCode: null,
        phoneNumber: null,
      },
      isLoading: false,
      sitekey: '6LdeWV8mAAAAAHY0jlSFBz91xn7HV6nyVVx-YHld',
      recaptchaToken: null,
    };
  },

  validations: {
    model: {
      phoneCode: {
        required,
        numeric,
        minLength: minLength(1),
      },
      phoneNumber: {
        required,
        numeric,
        minLength: minLength(10),
      },
    },
  },

  computed: {
    ...mapGetters('configuration', {
      country: 'getCountry',
      countries: 'getCountries',
      phoneMask: 'getPhoneMask',
    }),
    phoneCode: {
      get() {
        return this.$store.state.registration.phoneCode;
      },
      set(val) {
        this.model.phoneCode = val.replace(/\D/g, '');
        this.$store.commit(`registration/${types.SET_PHONE_CODE}`, val.replace(/\D/g, ''));
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.registration.phoneNumber;
      },
      set(val) {
        this.model.phoneNumber = val.replace(/\D/g, '');
        this.$store.commit(`registration/${types.SET_PHONE_NUMBER}`, val.replace(/\D/g, ''));
      },
    },
    isProduction() {
      const url = location.host.split('.');
      return url[url.length - 1] === 'ru';
    },
  },

  mounted() {
    new InputMask(this.phoneMask).mask(this.$refs.phoneNumberField);

    // Initiallize phoneCode

    if (this.phoneCode === null) {
      this.phoneCode = this.$store.getters['configuration/getPhoneCode'].replace(/\D/g, '');
    }

    // Populate model

    if (this.model.phoneCode === null) {
      this.model.phoneCode = this.phoneCode;
    }

    if (this.model.phoneNumber === null) {
      this.model.phoneNumber = this.phoneNumber;
    }

    if (this.$route.params.message) {
      this.message = this.$route.params.message;
    }

    this.$store.commit(`registration/${types.SET_PASSWORD}`, null);
    this.$store.commit(`registration/${types.SET_REPEAT_PASSWORD}`, null);

    // Initialize model validation

    this.$v.$touch();
  },

  methods: {
    ...mapActions('configuration', ['setCountry']),

    onCaptchaVerified(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
      this.handleSubmit();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },

    onPhoneCodeChange(phoneCode, country) {
      this.isMaskListVisible = false;
      this.setCountry(country);
    },

    onBeforeRequest() {
      this.mask();
    },

    onAfterRequest() {
      this.unmask();
    },
    submitTelNumber() {
      if (this.isInvalidRequestParams() && this.phoneNumber.length) {
        this.setResponseError('Некорректный номер телефона');
        return;
      }
      if (this.isInvalidRequestParams() && !this.phoneNumber.length) {
        this.setResponseError('Укажите номер телефона');
        return;
      }

      if (this.isProduction) {
        this.$refs.recaptcha.execute();
      } else {
        this.handleSubmit();
      }
    },
    handleRequestUrl() {
      return '/phone-number/send-security-code';
    },
    handleRequestParams() {
      const res = {
        token_scope: 'enter-phone-number',
        phone_code: this.phoneCode,
        phone_number: this.phoneNumber,
        country: this.country,
      };

      if (this.recaptchaToken) {
        res.recaptchaToken = this.recaptchaToken;
      }

      return res;
    },

    handleResponse(response) {
      switch (this.getResponceStatusCode(response)) {
        case responseCodes.RESPONSE_SECURITY_CODE_WAS_SENT:
          this.$router.push({ name: 'enter-sms-code' });
          break;

        default:
          this.setResponseError('Ошибка генерации токена');
      }
    },
  },
};
</script>
